export default __webpack_public_path__ + "static/media/team-2.d535cc13.jpg";